/**
 * Map of MCC (mobile country code) as per ITU [1] to ISO 3166 country code [2].
 *
 * [1] https://www.itu.int/dms_pub/itu-t/opb/sp/T-SP-E.212A-2017-PDF-E.pdf
 * [2] https://www.iso.org/iso-3166-country-codes.html
 */
export const mcc2iso: Readonly<
	Record<string, { alpha2: string; alpha3: string; name: string }>
> = {
	'202': { name: 'Greece', alpha2: 'GR', alpha3: 'GRC' },
	'204': { name: 'Netherlands', alpha2: 'NL', alpha3: 'NLD' },
	'206': { name: 'Belgium', alpha2: 'BE', alpha3: 'BEL' },
	'208': { name: 'France', alpha2: 'FR', alpha3: 'FRA' },
	'212': { name: 'Monaco', alpha2: 'MC', alpha3: 'MCO' },
	'213': { name: 'Andorra', alpha2: 'AD', alpha3: 'AND' },
	'214': { name: 'Spain', alpha2: 'ES', alpha3: 'ESP' },
	'216': { name: 'Hungary', alpha2: 'HU', alpha3: 'HUN' },
	'218': { name: 'Bosnia and Herzegovina', alpha2: 'BA', alpha3: 'BIH' },
	'219': { name: 'Croatia', alpha2: 'HR', alpha3: 'HRV' },
	'220': { name: 'Serbia', alpha2: 'RS', alpha3: 'SRB' },
	'221': { name: 'Kosovo', alpha2: 'XK', alpha3: 'XXK' },
	'222': { name: 'Italy', alpha2: 'IT', alpha3: 'ITA' },
	'225': { name: 'Holy See', alpha2: 'VA', alpha3: 'VAT' },
	'226': { name: 'Romania', alpha2: 'RO', alpha3: 'ROU' },
	'228': { name: 'Switzerland', alpha2: 'CH', alpha3: 'CHE' },
	'230': { name: 'Czechia', alpha2: 'CZ', alpha3: 'CZE' },
	'231': { name: 'Slovakia', alpha2: 'SK', alpha3: 'SVK' },
	'232': { name: 'Austria', alpha2: 'AT', alpha3: 'AUT' },
	'234': {
		name: 'United Kingdom of Great Britain and Northern Ireland',
		alpha2: 'GB',
		alpha3: 'GBR',
	},
	'235': {
		name: 'United Kingdom of Great Britain and Northern Ireland',
		alpha2: 'GB',
		alpha3: 'GBR',
	},
	'238': { name: 'Denmark', alpha2: 'DK', alpha3: 'DNK' },
	'240': { name: 'Sweden', alpha2: 'SE', alpha3: 'SWE' },
	'242': { name: 'Norway', alpha2: 'NO', alpha3: 'NOR' },
	'244': { name: 'Finland', alpha2: 'FI', alpha3: 'FIN' },
	'246': { name: 'Lithuania', alpha2: 'LT', alpha3: 'LTU' },
	'247': { name: 'Latvia', alpha2: 'LV', alpha3: 'LVA' },
	'248': { name: 'Estonia', alpha2: 'EE', alpha3: 'EST' },
	'250': { name: 'Russian Federation', alpha2: 'RU', alpha3: 'RUS' },
	'255': { name: 'Ukraine', alpha2: 'UA', alpha3: 'UKR' },
	'257': { name: 'Belarus', alpha2: 'BY', alpha3: 'BLR' },
	'259': { name: 'Moldova', alpha2: 'MD', alpha3: 'MDA' },
	'260': { name: 'Poland', alpha2: 'PL', alpha3: 'POL' },
	'262': { name: 'Germany', alpha2: 'DE', alpha3: 'DEU' },
	'266': { name: 'Gibraltar', alpha2: 'GI', alpha3: 'GIB' },
	'268': { name: 'Portugal', alpha2: 'PT', alpha3: 'PRT' },
	'270': { name: 'Luxembourg', alpha2: 'LU', alpha3: 'LUX' },
	'272': { name: 'Ireland', alpha2: 'IE', alpha3: 'IRL' },
	'274': { name: 'Iceland', alpha2: 'IS', alpha3: 'ISL' },
	'276': { name: 'Albania', alpha2: 'AL', alpha3: 'ALB' },
	'278': { name: 'Malta', alpha2: 'MT', alpha3: 'MLT' },
	'280': { name: 'Cyprus', alpha2: 'CY', alpha3: 'CYP' },
	'282': { name: 'Georgia', alpha2: 'GE', alpha3: 'GEO' },
	'283': { name: 'Armenia', alpha2: 'AM', alpha3: 'ARM' },
	'284': { name: 'Bulgaria', alpha2: 'BG', alpha3: 'BGR' },
	'286': { name: 'Türkiye', alpha2: 'TR', alpha3: 'TUR' },
	'288': { name: 'Faroe Islands', alpha2: 'FO', alpha3: 'FRO' },
	'290': { name: 'Greenland', alpha2: 'GL', alpha3: 'GRL' },
	'292': { name: 'San Marino', alpha2: 'SM', alpha3: 'SMR' },
	'293': { name: 'Slovenia', alpha2: 'SI', alpha3: 'SVN' },
	'294': { name: 'North Macedonia', alpha2: 'MK', alpha3: 'MKD' },
	'295': { name: 'Liechtenstein', alpha2: 'LI', alpha3: 'LIE' },
	'297': { name: 'Montenegro', alpha2: 'ME', alpha3: 'MNE' },
	'302': { name: 'Canada', alpha2: 'CA', alpha3: 'CAN' },
	'308': { name: 'Saint Pierre and Miquelon', alpha2: 'PM', alpha3: 'SPM' },
	'310': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'311': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'312': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'313': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'314': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'315': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'316': { name: 'United States of America', alpha2: 'US', alpha3: 'USA' },
	'330': { name: 'Puerto Rico', alpha2: 'PR', alpha3: 'PRI' },
	'332': { name: 'Virgin Islands (U.S.)', alpha2: 'VI', alpha3: 'VIR' },
	'334': { name: 'Mexico', alpha2: 'MX', alpha3: 'MEX' },
	'338': { name: 'Jamaica', alpha2: 'JM', alpha3: 'JAM' },
	'340': { name: 'Martinique', alpha2: 'MQ', alpha3: 'MTQ' },
	'342': { name: 'Barbados', alpha2: 'BB', alpha3: 'BRB' },
	'344': { name: 'Antigua and Barbuda', alpha2: 'AG', alpha3: 'ATG' },
	'346': { name: 'Cayman Islands', alpha2: 'KY', alpha3: 'CYM' },
	'348': { name: 'Virgin Islands (British)', alpha2: 'VG', alpha3: 'VGB' },
	'350': { name: 'Bermuda', alpha2: 'BM', alpha3: 'BMU' },
	'352': { name: 'Grenada', alpha2: 'GD', alpha3: 'GRD' },
	'354': { name: 'Montserrat', alpha2: 'MS', alpha3: 'MSR' },
	'356': { name: 'Saint Kitts and Nevis', alpha2: 'KN', alpha3: 'KNA' },
	'358': { name: 'Saint Lucia', alpha2: 'LC', alpha3: 'LCA' },
	'360': {
		name: 'Saint Vincent and the Grenadines',
		alpha2: 'VC',
		alpha3: 'VCT',
	},
	'362': {
		name: 'Bonaire, Sint Eustatius and Saba',
		alpha2: 'BQ',
		alpha3: 'BES',
	},
	'363': { name: 'Aruba', alpha2: 'AW', alpha3: 'ABW' },
	'364': { name: 'Bahamas', alpha2: 'BS', alpha3: 'BHS' },
	'365': { name: 'Anguilla', alpha2: 'AI', alpha3: 'AIA' },
	'366': { name: 'Dominica', alpha2: 'DM', alpha3: 'DMA' },
	'368': { name: 'Cuba', alpha2: 'CU', alpha3: 'CUB' },
	'370': { name: 'Dominican Republic', alpha2: 'DO', alpha3: 'DOM' },
	'372': { name: 'Haiti', alpha2: 'HT', alpha3: 'HTI' },
	'374': { name: 'Trinidad and Tobago', alpha2: 'TT', alpha3: 'TTO' },
	'376': { name: 'Turks and Caicos Islands', alpha2: 'TC', alpha3: 'TCA' },
	'400': { name: 'Azerbaijan', alpha2: 'AZ', alpha3: 'AZE' },
	'401': { name: 'Kazakhstan', alpha2: 'KZ', alpha3: 'KAZ' },
	'402': { name: 'Bhutan', alpha2: 'BT', alpha3: 'BTN' },
	'404': { name: 'India', alpha2: 'IN', alpha3: 'IND' },
	'405': { name: 'India', alpha2: 'IN', alpha3: 'IND' },
	'406': { name: 'India', alpha2: 'IN', alpha3: 'IND' },
	'410': { name: 'Pakistan', alpha2: 'PK', alpha3: 'PAK' },
	'412': { name: 'Afghanistan', alpha2: 'AF', alpha3: 'AFG' },
	'413': { name: 'Sri Lanka', alpha2: 'LK', alpha3: 'LKA' },
	'414': { name: 'Myanmar', alpha2: 'MM', alpha3: 'MMR' },
	'415': { name: 'Lebanon', alpha2: 'LB', alpha3: 'LBN' },
	'416': { name: 'Jordan', alpha2: 'JO', alpha3: 'JOR' },
	'417': { name: 'Syrian Arab Republic', alpha2: 'SY', alpha3: 'SYR' },
	'418': { name: 'Iraq', alpha2: 'IQ', alpha3: 'IRQ' },
	'419': { name: 'Kuwait', alpha2: 'KW', alpha3: 'KWT' },
	'420': { name: 'Saudi Arabia', alpha2: 'SA', alpha3: 'SAU' },
	'421': { name: 'Yemen', alpha2: 'YE', alpha3: 'YEM' },
	'422': { name: 'Oman', alpha2: 'OM', alpha3: 'OMN' },
	'424': { name: 'United Arab Emirates', alpha2: 'AE', alpha3: 'ARE' },
	'425': { name: 'Israel', alpha2: 'IL', alpha3: 'ISR' },
	'426': { name: 'Bahrain', alpha2: 'BH', alpha3: 'BHR' },
	'427': { name: 'Qatar', alpha2: 'QA', alpha3: 'QAT' },
	'428': { name: 'Mongolia', alpha2: 'MN', alpha3: 'MNG' },
	'429': { name: 'Nepal', alpha2: 'NP', alpha3: 'NPL' },
	'430': { name: 'United Arab Emirates', alpha2: 'AE', alpha3: 'ARE' },
	'431': { name: 'United Arab Emirates', alpha2: 'AE', alpha3: 'ARE' },
	'432': { name: 'Iran', alpha2: 'IR', alpha3: 'IRN' },
	'434': { name: 'Uzbekistan', alpha2: 'UZ', alpha3: 'UZB' },
	'436': { name: 'Tajikistan', alpha2: 'TJ', alpha3: 'TJK' },
	'437': { name: 'Kyrgyzstan', alpha2: 'KG', alpha3: 'KGZ' },
	'438': { name: 'Turkmenistan', alpha2: 'TM', alpha3: 'TKM' },
	'440': { name: 'Japan', alpha2: 'JP', alpha3: 'JPN' },
	'441': { name: 'Japan', alpha2: 'JP', alpha3: 'JPN' },
	'450': { name: 'Korea', alpha2: 'KR', alpha3: 'KOR' },
	'452': { name: 'Viet Nam', alpha2: 'VN', alpha3: 'VNM' },
	'454': { name: 'Hong Kong', alpha2: 'HK', alpha3: 'HKG' },
	'455': { name: 'Macao', alpha2: 'MO', alpha3: 'MAC' },
	'456': { name: 'Cambodia', alpha2: 'KH', alpha3: 'KHM' },
	'457': {
		name: "Lao People's Democratic Republic",
		alpha2: 'LA',
		alpha3: 'LAO',
	},
	'460': { name: 'China', alpha2: 'CN', alpha3: 'CHN' },
	'461': { name: 'China', alpha2: 'CN', alpha3: 'CHN' },
	'466': { name: 'Taiwan', alpha2: 'TW', alpha3: 'TWN' },
	'467': {
		name: "Democratic People's Republic of Korea",
		alpha2: 'KP',
		alpha3: 'PRK',
	},
	'470': { name: 'Bangladesh', alpha2: 'BD', alpha3: 'BGD' },
	'472': { name: 'Maldives', alpha2: 'MV', alpha3: 'MDV' },
	'502': { name: 'Malaysia', alpha2: 'MY', alpha3: 'MYS' },
	'505': { name: 'Australia', alpha2: 'AU', alpha3: 'AUS' },
	'510': { name: 'Indonesia', alpha2: 'ID', alpha3: 'IDN' },
	'514': { name: 'Timor-Leste', alpha2: 'TL', alpha3: 'TLS' },
	'515': { name: 'Philippines', alpha2: 'PH', alpha3: 'PHL' },
	'520': { name: 'Thailand', alpha2: 'TH', alpha3: 'THA' },
	'525': { name: 'Singapore', alpha2: 'SG', alpha3: 'SGP' },
	'528': { name: 'Brunei Darussalam', alpha2: 'BN', alpha3: 'BRN' },
	'530': { name: 'New Zealand', alpha2: 'NZ', alpha3: 'NZL' },
	'536': { name: 'Nauru', alpha2: 'NR', alpha3: 'NRU' },
	'537': { name: 'Papua New Guinea', alpha2: 'PG', alpha3: 'PNG' },
	'539': { name: 'Tonga', alpha2: 'TO', alpha3: 'TON' },
	'540': { name: 'Solomon Islands', alpha2: 'SB', alpha3: 'SLB' },
	'541': { name: 'Vanuatu', alpha2: 'VU', alpha3: 'VUT' },
	'542': { name: 'Fiji', alpha2: 'FJ', alpha3: 'FJI' },
	'543': { name: 'Wallis and Futuna', alpha2: 'WF', alpha3: 'WLF' },
	'544': { name: 'American Samoa', alpha2: 'AS', alpha3: 'ASM' },
	'545': { name: 'Kiribati', alpha2: 'KI', alpha3: 'KIR' },
	'546': { name: 'New Caledonia', alpha2: 'NC', alpha3: 'NCL' },
	'547': { name: 'French Polynesia', alpha2: 'PF', alpha3: 'PYF' },
	'548': { name: 'Cook Islands', alpha2: 'CK', alpha3: 'COK' },
	'549': { name: 'Samoa', alpha2: 'WS', alpha3: 'WSM' },
	'550': { name: 'Micronesia', alpha2: 'FM', alpha3: 'FSM' },
	'551': { name: 'Marshall Islands', alpha2: 'MH', alpha3: 'MHL' },
	'552': { name: 'Palau', alpha2: 'PW', alpha3: 'PLW' },
	'553': { name: 'Tuvalu', alpha2: 'TV', alpha3: 'TUV' },
	'554': { name: 'Tokelau', alpha2: 'TK', alpha3: 'TKL' },
	'555': { name: 'Niue', alpha2: 'NU', alpha3: 'NIU' },
	'602': { name: 'Egypt', alpha2: 'EG', alpha3: 'EGY' },
	'603': { name: 'Algeria', alpha2: 'DZ', alpha3: 'DZA' },
	'604': { name: 'Morocco', alpha2: 'MA', alpha3: 'MAR' },
	'605': { name: 'Tunisia', alpha2: 'TN', alpha3: 'TUN' },
	'606': { name: 'Libya', alpha2: 'LY', alpha3: 'LBY' },
	'607': { name: 'Gambia', alpha2: 'GM', alpha3: 'GMB' },
	'608': { name: 'Senegal', alpha2: 'SN', alpha3: 'SEN' },
	'609': { name: 'Mauritania', alpha2: 'MR', alpha3: 'MRT' },
	'610': { name: 'Mali', alpha2: 'ML', alpha3: 'MLI' },
	'611': { name: 'Guinea', alpha2: 'GN', alpha3: 'GIN' },
	'612': { name: "Côte d'Ivoire", alpha2: 'CI', alpha3: 'CIV' },
	'613': { name: 'Burkina Faso', alpha2: 'BF', alpha3: 'BFA' },
	'614': { name: 'Niger', alpha2: 'NE', alpha3: 'NER' },
	'615': { name: 'Togo', alpha2: 'TG', alpha3: 'TGO' },
	'616': { name: 'Benin', alpha2: 'BJ', alpha3: 'BEN' },
	'617': { name: 'Mauritius', alpha2: 'MU', alpha3: 'MUS' },
	'618': { name: 'Liberia', alpha2: 'LR', alpha3: 'LBR' },
	'619': { name: 'Sierra Leone', alpha2: 'SL', alpha3: 'SLE' },
	'620': { name: 'Ghana', alpha2: 'GH', alpha3: 'GHA' },
	'621': { name: 'Nigeria', alpha2: 'NG', alpha3: 'NGA' },
	'622': { name: 'Chad', alpha2: 'TD', alpha3: 'TCD' },
	'623': { name: 'Central African Republic', alpha2: 'CF', alpha3: 'CAF' },
	'624': { name: 'Cameroon', alpha2: 'CM', alpha3: 'CMR' },
	'625': { name: 'Cabo Verde', alpha2: 'CV', alpha3: 'CPV' },
	'626': { name: 'Sao Tome and Principe', alpha2: 'ST', alpha3: 'STP' },
	'627': { name: 'Equatorial Guinea', alpha2: 'GQ', alpha3: 'GNQ' },
	'628': { name: 'Gabon', alpha2: 'GA', alpha3: 'GAB' },
	'629': { name: 'Congo', alpha2: 'CG', alpha3: 'COG' },
	'630': {
		name: 'Democratic Republic of the Congo',
		alpha2: 'CD',
		alpha3: 'COD',
	},
	'631': { name: 'Angola', alpha2: 'AO', alpha3: 'AGO' },
	'632': { name: 'Guinea-Bissau', alpha2: 'GW', alpha3: 'GNB' },
	'633': { name: 'Seychelles', alpha2: 'SC', alpha3: 'SYC' },
	'634': { name: 'Sudan', alpha2: 'SD', alpha3: 'SDN' },
	'635': { name: 'Rwanda', alpha2: 'RW', alpha3: 'RWA' },
	'636': { name: 'Ethiopia', alpha2: 'ET', alpha3: 'ETH' },
	'637': { name: 'Somalia', alpha2: 'SO', alpha3: 'SOM' },
	'638': { name: 'Djibouti', alpha2: 'DJ', alpha3: 'DJI' },
	'639': { name: 'Kenya', alpha2: 'KE', alpha3: 'KEN' },
	'640': { name: 'Tanzania', alpha2: 'TZ', alpha3: 'TZA' },
	'641': { name: 'Uganda', alpha2: 'UG', alpha3: 'UGA' },
	'642': { name: 'Burundi', alpha2: 'BI', alpha3: 'BDI' },
	'643': { name: 'Mozambique', alpha2: 'MZ', alpha3: 'MOZ' },
	'645': { name: 'Zambia', alpha2: 'ZM', alpha3: 'ZMB' },
	'646': { name: 'Madagascar', alpha2: 'MG', alpha3: 'MDG' },
	'647': { name: 'French Southern Territories', alpha2: 'TF', alpha3: 'ATF' },
	'648': { name: 'Zimbabwe', alpha2: 'ZW', alpha3: 'ZWE' },
	'649': { name: 'Namibia', alpha2: 'NA', alpha3: 'NAM' },
	'650': { name: 'Malawi', alpha2: 'MW', alpha3: 'MWI' },
	'651': { name: 'Lesotho', alpha2: 'LS', alpha3: 'LSO' },
	'652': { name: 'Botswana', alpha2: 'BW', alpha3: 'BWA' },
	'653': { name: 'Eswatini', alpha2: 'SZ', alpha3: 'SWZ' },
	'654': { name: 'Comoros', alpha2: 'KM', alpha3: 'COM' },
	'655': { name: 'South Africa', alpha2: 'ZA', alpha3: 'ZAF' },
	'657': { name: 'Eritrea', alpha2: 'ER', alpha3: 'ERI' },
	'658': {
		name: 'Saint Helena, Ascension and Tristan da Cunha',
		alpha2: 'SH',
		alpha3: 'SHN',
	},
	'659': { name: 'South Sudan', alpha2: 'SS', alpha3: 'SSD' },
	'702': { name: 'Belize', alpha2: 'BZ', alpha3: 'BLZ' },
	'704': { name: 'Guatemala', alpha2: 'GT', alpha3: 'GTM' },
	'706': { name: 'El Salvador', alpha2: 'SV', alpha3: 'SLV' },
	'708': { name: 'Honduras', alpha2: 'HN', alpha3: 'HND' },
	'710': { name: 'Nicaragua', alpha2: 'NI', alpha3: 'NIC' },
	'712': { name: 'Costa Rica', alpha2: 'CR', alpha3: 'CRI' },
	'714': { name: 'Panama', alpha2: 'PA', alpha3: 'PAN' },
	'716': { name: 'Peru', alpha2: 'PE', alpha3: 'PER' },
	'722': { name: 'Argentina', alpha2: 'AR', alpha3: 'ARG' },
	'724': { name: 'Brazil', alpha2: 'BR', alpha3: 'BRA' },
	'730': { name: 'Chile', alpha2: 'CL', alpha3: 'CHL' },
	'732': { name: 'Colombia', alpha2: 'CO', alpha3: 'COL' },
	'734': { name: 'Venezuela', alpha2: 'VE', alpha3: 'VEN' },
	'736': { name: 'Bolivia', alpha2: 'BO', alpha3: 'BOL' },
	'738': { name: 'Guyana', alpha2: 'GY', alpha3: 'GUY' },
	'740': { name: 'Ecuador', alpha2: 'EC', alpha3: 'ECU' },
	'742': { name: 'French Guiana', alpha2: 'GF', alpha3: 'GUF' },
	'744': { name: 'Paraguay', alpha2: 'PY', alpha3: 'PRY' },
	'746': { name: 'Suriname', alpha2: 'SR', alpha3: 'SUR' },
	'748': { name: 'Uruguay', alpha2: 'UY', alpha3: 'URY' },
	'750': { name: 'Falkland Islands', alpha2: 'FK', alpha3: 'FLK' },
} as const
